import { render } from "./DeveloperMisc.vue?vue&type=template&id=077b985f"
import script from "./DeveloperMisc.vue?vue&type=script&lang=js"
export * from "./DeveloperMisc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__